import axiosInstance from './axiosInstance';

export interface ReferralInfo {
  referral_code: string | null;
  referral_link: string;
  total_referred: number;
  credits_earned: number;
  referral_limit: number;
  referrals_remaining: number;
}

export const referralService = {
  async getReferralInfo(): Promise<ReferralInfo> {
    const response = await axiosInstance.get<ReferralInfo>('/api/v1/referral/info');

    return response.data;
  },
};
